import { render, staticRenderFns } from "./NewClientDomain.vue?vue&type=template&id=17743bd0&"
import script from "./NewClientDomain.vue?vue&type=script&lang=js&"
export * from "./NewClientDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17743bd0')) {
      api.createRecord('17743bd0', component.options)
    } else {
      api.reload('17743bd0', component.options)
    }
    module.hot.accept("./NewClientDomain.vue?vue&type=template&id=17743bd0&", function () {
      api.rerender('17743bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/NewClientDomain.vue"
export default component.exports